<template>
  <nav :class="[
    'navbar',
    'navbar-expand-lg',
    'sticky-top',
    'navbar-light',
    'bg-primary',
    'px-md-16',
    'py-1',
    { 'navbar-bounce': isScrollingUp, 'navbar-hidden': !isNavbarVisible },
  ]">
    <div class="d-flex align-items-center navbar-brand-container">
      <img :src="logo" alt="Logo" class="logo mr-2" />
      <router-link class="navbar-brand text-white" to="/">MERO PRINTS</router-link>
    </div>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
      aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-between" id="navbarNavDropdown">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <router-link class="nav-link text-white" to="/service">Service</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link text-white" to="/contact">Contact</router-link>
        </li>
         <!-- <li class="nav-item">
          <router-link class="nav-link text-white login-link d-flex align-center " to="/authentication/login">
            Login Account
          </router-link>
        </li> -->
        <!-- Cart and Profile Icons -->
      <ul class="navbar-nav ml-2 d-flex align-items-center">
        <!-- Cart Icon -->
        <li v-if="cartCount > 0" class="nav-item cart-icon-container">
          <router-link class="nav-link text-white" to="/cart">
            <i class="fas fa-shopping-cart"></i>
            <span class="cart-count">{{ cartCount }}</span>
          </router-link>
        </li>

        <!-- Profile Icon -->
        <!-- <li class="nav-item">
          <a class="nav-link text-white" href="#">
            <i class="fas fa-user bg-white text-primary rounded-circle d-flex justify-content-center align-items-center"
              style="width: 30px; height: 30px; font-size: 16px"></i>
          </a>
        </li> -->

         <!-- <li class="nav-item">
          <router-link class="nav-link text-white login-link d-flex align-center " to="/authentication/login">
            Login Account
          </router-link>
        </li> -->
        <li class="nav-item">
          <router-link class="nav-link text-white login-link d-flex align-center " to="/authentication/login">
            Login Account
          </router-link>
        </li>
      </ul>
        <!-- <li class="nav-item">
          <router-link class="nav-link text-white login-link d-flex align-center disabled" to="/authentication/login">
            Login Account
          </router-link>
        </li> -->
       
      </ul>
    </div>
  </nav>

  <div class="d-flex justify-start ml-md-16">
    <BreadCrumbNav />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import logo from "@/assets/images/logos/LOGO-1.png";
import { useCartStore } from "@/Store/cartStore";
import BreadCrumbNav from "@/components/SharedUI/BreadCrumb.vue";
import { cards } from "@/Store/data/cards.js";
const cartStore = useCartStore();
const cartCount = computed(() => cartStore.cartCount);
const prevScrollY = ref(0); // Track previous scroll position
const isScrollingUp = ref(false); // Whether user is scrolling up or down
const isNavbarVisible = ref(true); // Controls visibility of the navbar

// Scroll listener to detect direction
const handleScroll = () => {
  const currentScrollY = window.scrollY;
  if (currentScrollY < prevScrollY.value) {
    // Scrolling up
    isScrollingUp.value = true;
    isNavbarVisible.value = true;
  } else {
    // Scrolling down
    isScrollingUp.value = false;
    isNavbarVisible.value = false;
  }
  prevScrollY.value = currentScrollY;
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped>
.bg-primary {
  background-color: #5761e7 !important;
}

.logo {
  max-width: 50px;
  width: 40px;
  height: auto;
}

.navbar-brand {
  font-family: "Inria Serif", serif;
  font-weight: 700;
  font-size: 30px;
  line-height: 48px;
}

.navbar-brand-container {
  display: flex;
  align-items: center;
}

.navbar-nav {
  display: flex;
  align-items: center;
}

.navbar-nav .nav-item {
  margin-right: 15px;
}

.navbar-nav .nav-item .nav-link {
  font-weight: 700;
  font-size: 20px;
}

.navbar-nav .nav-item .login-link {
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  padding: 0.5rem 1rem;
  /* box-shadow: 0 0 10px rgba(255, 255, 255, 0.7); */
  color: #ffdb4d;
  border: 2px solid #e8e9f3;
  border-radius: 7px;
}

.navbar-nav .nav-item .login-link:hover {
  box-shadow: 0 0 10px rgba(240, 130, 130, 0.7);
  color: #f0e5bc;
}

.cart-icon-container {
  position: relative;
}

.cart-count {
  position: absolute;
  top: 0px;
  right: -10px;
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 0.2em 0.3em;
  font-size: 12px;
  font-weight: bold;
  width: 22px;
  text-align: center;
  height: 22px;
}

/* .navbar-bounce {
  animation: bounce 0.5s ease-out;
}

.navbar-hidden {
  transform: translateY(-100%);
  transition: transform 0.3s ease-out;
} */

/* @keyframes bounce {
  0% {
    transform: translateY(-10px);
  }
  50% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0);
  }
} */

@media (max-width: 767px) {
  .navbar-brand {
    font-size: 30px;
    line-height: 36px;
    margin-left: 0;
  }

  .navbar-nav {
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;
  }

  .nav-item {
    margin-right: 0;
    margin-bottom: 0.5rem;
  }

  .nav-link {
    font-size: 16px;
  }
}

.navbar-toggler {
  border: none;
  position: absolute;
  right: 1rem;
  top: 0.6rem;
  z-index: 2;
}

/* Padding Adjustments */
.navbar {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

@media (max-width: 767px) {
  .navbar {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>
